import React from 'react';

const Home: React.FC = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <h1>Hello World</h1>
        </div>
      </div>
    </div>
  );
};

export default Home;
